import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import type { FeatureView } from './types/feature';

interface FeatureCustomData {
	default_view: FeatureView;
	hide_all_features_button: boolean;
	custom_title: string;
	custom_description: string;
}

const el = document.querySelector<HTMLElement>('#feature');

const lightboxWrapper = document.createElement('div');
lightboxWrapper.id = 'lightbox-wrapper';
document.body.appendChild(lightboxWrapper);

if (el) {
	const root = ReactDOM.createRoot(el);

	const { default_view, hide_all_features_button, custom_title, custom_description }: FeatureCustomData = JSON.parse(el.dataset.customData ?? '{}');

	root.render(
		<StrictMode>
			<App
				customDescription={custom_description}
				customTitle={custom_title}
				hideAllFeaturesButton={hide_all_features_button}
				restUrl={el.dataset.restUrl ?? ''}
				view={default_view}
			/>
		</StrictMode>,
	);
}
